import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import Logo from "../images/tomo_logo_white_green.svg";
import PromoBanner from "./PromoBanner";
// import Logo from "../images/tomo_fall_logo.svg";

const Header = ({ setShowTooltip = () => {} }) => {
  useEffect(() => {
    // initialize to opposite of current scrollY so scrollFn always runs initially
    let lastScrollY = !window.scrollY;

    const scrollFn = () => {
      if (!!window.scrollY === !!lastScrollY) { return; }
      lastScrollY = window.scrollY;

      if (window.scrollY) { document.body.classList.add("scrolled"); } else { document.body.classList.remove("scrolled"); }
    };

    window.addEventListener("scroll", scrollFn);
    scrollFn();
  }, []);

  return (
    <div>
      {/* <PromoBanner /> */}
      <header className="py-3 md:py-5 flex justify-between items-center px-6 md:px-8 max-w-page bg-transparent">
        <div className="mr-4 ml-1 lg:ml-0 lg:mr-2 xl:mr-12 inline-block pb-1">
          <Link to="/">
            <img
              src={Logo}
              alt=""
              className="w-11/12 md:w-32"
              style={{ width: 123, height: 32 }}
            />
          </Link>
        </div>

        <div className="flex-1 text-dark md:hidden lg:inline-flex items-center">
          <Link
            to="/ai"
            className="px-4 xl:px-6 text-white hidden md:inline-block hover:text-gray-700 whitespace-nowrap font-medium text-lg"
          >
            TomoAI
          </Link>
          <a
            href="https://tomocredit.com/blog/"
            className="px-4 xl:px-6 text-white hidden md:inline-block hover:text-gray-700 whitespace-nowrap font-medium text-lg"
            rel="noreferrer"
          >
            Blog
          </a>
          <Link
            to="/faq"
            className="px-4 xl:px-6 text-white hidden md:inline-block hover:text-gray-700 whitespace-nowrap font-medium text-lg"
          >
            FAQs
          </Link>
          <Link
            to="/about"
            className="px-4 xl:px-6 text-white hidden md:inline-block hover:text-gray-700 whitespace-nowrap font-medium text-lg"
          >
            About
          </Link>

          <span className="flex-1" />

          <a
            href="/dashboard"
            className="px-4 xl:px-6 text-white hidden md:inline-block hover:text-gray-700 whitespace-nowrap font-medium text-base"
          >
            Login
          </a>

          {/* <Link to="/">
            <button
              type="button"
              onClick={() => {
                setShowTooltip(true);
                window.scrollTo(0, 0);
              }}
              className="gtm-get-started bg-primary-btn hover:bg-gray-800 hover:text-primary text-black py-2 px-4 xl:px-6 rounded-md text-center hidden md:inline-block text-base whitespace-nowrap shadow-2xl font-bold"
            >
              Get started
            </button>
          </Link> */}
        </div>
      </header>
    </div>
  );
};

Header.propTypes = {
  setShowTooltip: PropTypes.func,
};

export default Header;
